<template>
  <profile-edit-section-card
    v-if="localState"
    title="Certifications"
    breadcrumb-label="Profile"
    :saving="isSaving"
    :has-unsaved-changes="hasUnsavedChanges"
    @breadcrumb-click="cancelEdit"
    @save="handleSave"
    @cancel="cancelEdit"
  >
    <fieldset>
      <legend class="form__label pb-8">Do you have any certifications?</legend>
      <p class="text-caption mb-16">Select all that apply. These are self-reported, not verified.</p>
      <ul>
        <li v-for="option in certificationOptions" :key="option.value" class="mb-8">
          <poppins-checkbox v-model="localState.certifications" :label-name="option.label" :value="option.value" />
        </li>
      </ul>
    </fieldset>
  </profile-edit-section-card>
</template>

<script lang="ts">
import PoppinsCheckbox from '@/components/checkbox/Checkbox.vue';
import ProfileEditSectionCard from '../../components/ProfileEditSectionCard.vue';
import profileEditMixin from '../../mixins/profileEditMixin';
import { CERTIFICATIONS_OPTIONS } from '../../__types__/CareTypeFormOptions';

const CERTIFICATION_VALUES = new Set(CERTIFICATIONS_OPTIONS.map((option) => option.value));

export default {
  name: 'CertificationsForm',
  components: {
    ProfileEditSectionCard,
    PoppinsCheckbox,
  },
  mixins: [profileEditMixin],
  data(): any {
    return {
      localState: null,
      originalState: null,
    };
  },
  computed: {
    certificationOptions: () => CERTIFICATIONS_OPTIONS,
    hasUnsavedChanges(): boolean {
      if (!this.localState || !this.originalState) return false;
      return JSON.stringify(this.localState) !== JSON.stringify(this.originalState);
    },
  },
  watch: {
    $route() {
      this.initializeFormState();
    },
    formState: {
      handler(newState) {
        if (newState) {
          this.initializeFormState();
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.initializeFormState();
  },
  methods: {
    uniqueValues(values: string[] = []): string[] {
      return Array.from(new Set(values.filter(Boolean)));
    },
    initializeFormState() {
      const state = this.formState as { qualifications?: string[] } | null;
      if (!state) return;

      this.localState = {
        certifications: this.uniqueValues(state.qualifications || []).filter((value) => CERTIFICATION_VALUES.has(value)),
      };
      this.originalState = JSON.parse(JSON.stringify(this.localState));
    },
    async handleSave() {
      if (!this.localState) return;

      if (this.hasUnsavedChanges) {
        const otherQualifications = this.uniqueValues(
          ((this.formState as { qualifications?: string[] })?.qualifications || []).filter(
            (value) => !CERTIFICATION_VALUES.has(value)
          )
        );
        await this.saveSection({
          qualifications: this.uniqueValues([...otherQualifications, ...this.localState.certifications]),
        });
      }
    },
  },
};
</script>
